/* VYRA theme – drawers, AJAX cart, product form with bundles, sticky bar, reveal animations */
(function () {
  'use strict';

  var T = window.theme || {};
  var S = T.strings || {};

  /* ---------------------------------------------------------------- money */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = parseInt(cents, 10);
    var fmt = format || T.moneyFormat || '{{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;

    function num(n, precision, thousands, decimal) {
      if (isNaN(n) || n === null) return '0';
      var fixed = (n / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }

    var match = fmt.match(re);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = num(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = num(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = num(cents, 0, ' ', ','); break;
      case 'amount_with_space_separator': value = num(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = num(cents, 2, ' ', '.'); break;
      default: value = num(cents, 2, ',', '.');
    }
    return fmt.replace(re, value).replace(/<[^>]*>/g, '');
  }

  function setText(el, text) { if (el) el.textContent = text; }

  /* -------------------------------------------------------------- drawers */
  var lastFocus = null;

  function openDrawer(name, opener) {
    var drawer = document.querySelector('[data-drawer="' + name + '"]');
    if (!drawer) return false;
    document.querySelectorAll('.drawer.is-open').forEach(function (d) { if (d !== drawer) closeDrawer(d, true); });
    lastFocus = opener || document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('is-locked');
    document.querySelectorAll('[data-drawer-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var panel = drawer.querySelector('.drawer__panel');
    window.setTimeout(function () { if (panel) panel.focus({ preventScroll: true }); }, 60);
    return true;
  }

  function closeDrawer(drawer, keepLock) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    var name = drawer.getAttribute('data-drawer');
    document.querySelectorAll('[data-drawer-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (!keepLock) {
      document.documentElement.classList.remove('is-locked');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var name = opener.getAttribute('data-drawer-open');
      if (name === 'cart' && document.body.classList.contains('template-cart')) return;
      if (openDrawer(name, opener)) e.preventDefault();
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest('.drawer'));
      return;
    }
    var link = e.target.closest('.drawer a[href]');
    if (link) {
      var href = link.getAttribute('href') || '';
      if (href.charAt(0) === '#' || (href.indexOf('#') > -1 && href.split('#')[0] === window.location.pathname)) {
        closeDrawer(link.closest('.drawer'));
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    var open = document.querySelector('.drawer.is-open');
    if (!open) return;
    if (e.key === 'Escape') { closeDrawer(open); return; }
    if (e.key === 'Tab') {
      var focusables = open.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === open.querySelector('.drawer__panel'))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ----------------------------------------------------------------- cart */
  var Cart = {
    sectionIds: function () {
      var ids = [];
      document.querySelectorAll('[data-cart-contents][data-section]').forEach(function (el) {
        var id = el.getAttribute('data-section');
        if (id && ids.indexOf(id) === -1) ids.push(id);
      });
      if (ids.indexOf('cart-drawer') === -1) ids.push('cart-drawer');
      return ids;
    },
    request: function (url, body) {
      body.sections = Cart.sectionIds().join(',');
      body.sections_url = window.location.pathname;
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) throw new Error(data.description || data.message || S.error);
          return data;
        });
      });
    },
    render: function (sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (id) {
        var html = sections[id];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-contents]');
        if (!fresh) return;
        document.querySelectorAll('[data-cart-contents][data-section="' + id + '"]').forEach(function (target) {
          target.replaceWith(fresh.cloneNode(true));
        });
      });
      Cart.updateCount();
    },
    updateCount: function () {
      var source = document.querySelector('[data-cart-contents][data-section="cart-drawer"]') || document.querySelector('[data-cart-contents]');
      if (!source) return;
      var n = parseInt(source.getAttribute('data-count') || '0', 10);
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = n;
        el.hidden = n === 0;
        el.classList.remove('is-bumped');
        void el.offsetWidth;
        el.classList.add('is-bumped');
      });
      document.querySelectorAll('[data-cart-count-label]').forEach(function (el) { el.textContent = '(' + n + ')'; });
    },
    add: function (items) {
      return Cart.request(T.routes.cartAdd + '.js', { items: items }).then(function (data) { Cart.render(data.sections); return data; });
    },
    change: function (line, quantity) {
      return Cart.request(T.routes.cartChange + '.js', { line: line, quantity: quantity }).then(function (data) { Cart.render(data.sections); return data; });
    }
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('[data-cart-contents]');
    if (wrap) wrap.classList.add('is-busy');
    Cart.change(parseInt(btn.getAttribute('data-line'), 10), Math.max(0, parseInt(btn.getAttribute('data-qty'), 10)))
      .catch(function (err) {
        if (wrap) wrap.classList.remove('is-busy');
        window.alert(err.message || S.error);
      });
  });

  /* -------------------------------------------------------------- product */
  function ProductForm(root) {
    this.root = root;
    var json = root.querySelector('[data-product-json]');
    if (!json) return;
    this.product = JSON.parse(json.textContent);
    this.form = root.querySelector('form[data-product-form]');
    this.idInput = root.querySelector('[data-variant-id]');
    this.qtyInput = root.querySelector('[data-qty-input]');
    this.addBtn = root.querySelector('[data-add-button]');
    this.addLabel = root.querySelector('[data-add-label]');
    this.error = root.querySelector('[data-form-error]');
    this.sticky = root.querySelector('[data-sticky-atc]');
    var currentId = this.idInput ? parseInt(this.idInput.value, 10) : null;
    this.variant = this.product.variants.filter(function (v) { return v.id === currentId; })[0] || this.product.variants[0];
    this.manualQty = 1;
    this.bind();
  }

  ProductForm.prototype.bind = function () {
    var self = this;
    var root = this.root;

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-input]')) self.onOptionChange();
      if (e.target.matches('[data-bundle-input]')) self.onBundleChange();
    });

    root.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-thumb]');
      if (thumb) { self.showMedia(thumb.getAttribute('data-thumb')); return; }
      var step = e.target.closest('[data-qty-step]');
      if (step) {
        self.manualQty = Math.max(1, Math.min(99, self.manualQty + parseInt(step.getAttribute('data-qty-step'), 10)));
        setText(root.querySelector('[data-qty-display]'), self.manualQty);
        self.update();
        return;
      }
      if (e.target.closest('[data-sticky-add]')) {
        e.preventDefault();
        self.submit();
      }
    });

    if (this.form) {
      this.form.addEventListener('submit', function (e) { e.preventDefault(); self.submit(); });
    }

    if (this.sticky && this.addBtn && 'IntersectionObserver' in window) {
      var stickyBtn = this.sticky.querySelector('[data-sticky-add]');
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        self.sticky.classList.toggle('is-visible', show);
        self.sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
      }, { threshold: 0 }).observe(this.addBtn);
    }

    this.update();
  };

  ProductForm.prototype.selectedOptions = function () {
    return Array.prototype.map.call(this.root.querySelectorAll('fieldset[data-option]'), function (fs) {
      var checked = fs.querySelector('input:checked');
      return checked ? checked.value : null;
    });
  };

  ProductForm.prototype.onOptionChange = function () {
    var opts = this.selectedOptions();
    var root = this.root;
    opts.forEach(function (val, i) { setText(root.querySelector('[data-option-label="' + i + '"]'), val); });
    this.variant = this.product.variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    })[0] || null;
    if (this.variant) {
      if (this.idInput) this.idInput.value = this.variant.id;
      if (this.variant.featured_media) this.showMedia(String(this.variant.featured_media.id));
      if (document.body.classList.contains('template-product') && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', this.variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    this.update();
  };

  ProductForm.prototype.onBundleChange = function () {
    this.root.querySelectorAll('.bundle').forEach(function (label) {
      var input = label.querySelector('[data-bundle-input]');
      label.classList.toggle('is-selected', !!(input && input.checked));
    });
    this.update();
  };

  ProductForm.prototype.selectedBundle = function () {
    return this.root.querySelector('[data-bundle-input]:checked');
  };

  ProductForm.prototype.quantity = function () {
    var b = this.selectedBundle();
    return b ? parseInt(b.value, 10) : this.manualQty;
  };

  ProductForm.prototype.update = function () {
    var v = this.variant;
    var root = this.root;
    if (!v) {
      if (this.addBtn) this.addBtn.disabled = true;
      setText(this.addLabel, S.unavailable || 'Nicht verfügbar');
      return;
    }

    setText(root.querySelector('[data-price]'), formatMoney(v.price));
    var compare = root.querySelector('[data-compare]');
    if (compare) {
      var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
      compare.hidden = !hasCompare;
      if (hasCompare) compare.textContent = formatMoney(v.compare_at_price);
    }

    var bestPer = v.price;
    root.querySelectorAll('.bundle').forEach(function (label) {
      var input = label.querySelector('[data-bundle-input]');
      var q = parseInt(input.value, 10);
      var disc = parseInt(input.getAttribute('data-discount') || '0', 10);
      var total = v.price * q - disc;
      var per = Math.floor(total / q);
      if (per < bestPer) bestPer = per;
      setText(label.querySelector('[data-bundle-total]'), formatMoney(total));
      setText(label.querySelector('[data-bundle-per]'), formatMoney(per));
    });
    setText(root.querySelector('[data-best-per]'), formatMoney(bestPer));

    var q = this.quantity();
    var b = this.selectedBundle();
    var discount = b ? parseInt(b.getAttribute('data-discount') || '0', 10) : 0;
    var ctaTotal = v.price * q - discount;
    if (this.qtyInput) this.qtyInput.value = q;
    setText(root.querySelector('[data-sticky-price]'), formatMoney(ctaTotal));

    if (this.addBtn && this.addLabel) {
      this.addBtn.disabled = !v.available;
      this.addLabel.textContent = '';
      if (v.available) {
        this.addLabel.appendChild(document.createTextNode('In den Warenkorb · '));
        var span = document.createElement('span');
        span.setAttribute('data-cta-price', '');
        span.textContent = formatMoney(ctaTotal);
        this.addLabel.appendChild(span);
      } else {
        this.addLabel.textContent = S.soldOut || 'Ausverkauft';
      }
    }
  };

  ProductForm.prototype.showMedia = function (id) {
    var root = this.root;
    var found = false;
    root.querySelectorAll('[data-media-id]').forEach(function (slide) {
      var active = slide.getAttribute('data-media-id') === String(id);
      if (active) found = true;
      slide.classList.toggle('is-active', active);
      if (!active) slide.querySelectorAll('video').forEach(function (vid) { vid.pause(); });
    });
    if (!found) return;
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(id));
    });
  };

  ProductForm.prototype.submit = function () {
    var self = this;
    if (!this.variant || !this.variant.available || !this.addBtn) return;
    this.addBtn.classList.add('is-loading');
    this.addBtn.disabled = true;
    if (this.error) this.error.hidden = true;
    Cart.add([{ id: this.variant.id, quantity: this.quantity() }])
      .then(function () { openDrawer('cart', self.addBtn); })
      .catch(function (err) {
        if (self.error) { self.error.textContent = err.message || S.error; self.error.hidden = false; }
      })
      .then(function () {
        self.addBtn.classList.remove('is-loading');
        self.addBtn.disabled = !(self.variant && self.variant.available);
      });
  };

  /* --------------------------------------------------------------- reveal */
  function initReveal() {
    var items = document.querySelectorAll('[data-reveal]');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ----------------------------------------------------------------- init */
  function init() {
    document.querySelectorAll('[data-product]').forEach(function (root) { new ProductForm(root); });
    initReveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-product]').forEach(function (root) { new ProductForm(root); });
    e.target.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); });
  });

  window.VyraCart = Cart;
})();
